module.exports = __webpack_public_path__ + "static/media/Hot peppers - Thai chilies.b2416344.png";